import { render, staticRenderFns } from "./poster-edit.vue?vue&type=template&id=100236af&scoped=true&"
import script from "./poster-edit.vue?vue&type=script&lang=js&"
export * from "./poster-edit.vue?vue&type=script&lang=js&"
import style0 from "./poster-edit.vue?vue&type=style&index=0&id=100236af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100236af",
  null
  
)

export default component.exports